import { Pipe, type PipeTransform } from '@angular/core';
import type { Maybe } from '@quipex/core/primitives';
import { toSentenceCase } from '@quipex/shared/utils';

@Pipe({
    name: 'qpxSentenceCase',
})
export class SentenceCasePipe implements PipeTransform {
    /**
     * Transforms a given string to sentence case, capitalizing only the first letter of the first word
     * and optionally converting the rest of the letters to lowercase.
     *
     * Example usage in a template:
     * ```
     * {{ 'hello WORLD from ANGULAR' | qpxSentenceCase }}
     * ```
     * This will render as:
     * ```
     * Hello world from angular
     * ```
     *
     * To preserve the original case of other characters:
     * ```
     * {{ 'hello WORLD from ANGULAR' | qpxSentenceCase:true }}
     * ```
     * This will render as:
     * ```
     * Hello WORLD from ANGULAR
     * ```
     *
     * @param value - The input string to transform.
     * @param preserveCase - If true, only capitalises first letter without lowercasing the rest. Defaults to false.
     * @returns The transformed string in sentence case.
     */
    transform(value: Maybe<string>, preserveCase = false): string {
        return toSentenceCase(value, preserveCase);
    }
}
